import {
  Box,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import IconBadge from '../../../components/IconBadge';

type Props = {
  title: string,
  backgroundColor: string,
  icon: React.FC<any>,
  typographyProps?: any,
};

const AccordionHeader = ({ title, backgroundColor, icon }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <IconBadge backgroundColor={backgroundColor} icon={icon} />
      <Typography
        variant="titleSmall"
        sx={{
          margin: 'auto 16px',
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default AccordionHeader;
